import { render } from "./PlayoutMode.vue?vue&type=template&id=55af8086"
import script from "./PlayoutMode.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutMode.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55af8086"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55af8086', __exports__)) {
    api.reload('55af8086', __exports__)
  }
  
  module.hot.accept("./PlayoutMode.vue?vue&type=template&id=55af8086", () => {
    api.rerender('55af8086', render)
  })

}


export default __exports__